import React, { FC, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { classNames, classnames, ddayjs } from '@dt/fe-utils'
import { thirdPartyMobx } from '@mobxStore'
import './index.scss'

interface IProps {
  disabled?: boolean; // 是否可选
  couponInfo: any;
  selected: boolean;
  onUse?: (data: any) => void;
}

const iconMap = {
  douyin: 'icon-douyin',
  meituan: 'icon-meituan',
  Koubei: 'icon-koubei'
}

const ThirdCouponItem: FC<IProps> = (props: IProps) => {
  const { couponInfo, selected, onUse, disabled } = props
  const [showFooter, setShowFooter] = useState<boolean>(false)
  const desc = couponInfo.sku?.title || ''
  const type = couponInfo.type
  const amount = couponInfo.sku.marketPrice / 100
  const switchCard = () => {
    if (disabled) return
    // thirdPartyMobx.setSelectCoupon({ ...couponInfo })
    onUse?.(couponInfo)
  }
  const timeStr = useMemo(() => {
    if (couponInfo.sku?.soldStartTime && couponInfo.expireTime) {
      const start = couponInfo.sku.soldStartTime * 1000
      const end = couponInfo.expireTime * 1000
      const startTime = ddayjs(start)
      const endTime = ddayjs(end)
      return `${startTime.format('YYYY-MM-DD')} ${i18n.t('mkt.common.to')} ${endTime.format('YYYY-MM-DD')}`
    }
    return ''
  }, [couponInfo])

  return (
    <div
      className={classNames('third-coupon-item', { disabled: disabled })}
      data-cypid={`click-third-coupon-item-${couponInfo?.couponCode}`}
      onClick={switchCard}
      style={{
        color: '#ffffff'
      }}
    >
      <div className='third-coupon-block-wrapper'>
        <div className={`third-coupon-block ${type}`}>
          {
            type === 'douyin' && (
              <>
                <div className='douyin-border left'></div>
                <div className='douyin-border right'></div>
              </>
            )
          }
          {
            type === 'Koubei' && (
              <div className='koubei-third-coupon-container'>
                <div className='koubei-third-coupon-detail'></div>
              </div>
            )
          }
          <div className='third-coupon-con'>
            <div className={classnames('header', { long: type !== 'Koubei' && desc.length > 10 })}>{type === 'Koubei' ? `¥${amount}` : desc || ''}</div>
            {
              type === 'Koubei' ? (
                <div className='name'>{desc}</div>
              ) : (
                <div className='time'>{timeStr}</div>
              )
            }
            <div className='coupon-code'>{i18n.t('menu.couponCode')}: {couponInfo.couponCode}</div>
          </div>
          <div className='third-coupon-icon'>
            <i className={`iconfont ${iconMap[type]}`}></i>
          </div>
        </div>
        {showFooter && (
          <div className='third-coupon-footer'>
          </div>
        )}
      </div>
      <div className='mcip-footer'>
        <div className='use-tip'>
          <i className={classNames('iconfont', (selected) ? 'icon-checked' : 'no-select')} />
        </div>
      </div>
    </div>
  )
}

export default observer(ThirdCouponItem)
